import { Flex } from "@chakra-ui/react";
import { Button, Input } from "@sgi/gravity";
import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { useEnterEmailProxy } from "../Custom Hooks/useEnterEmailProxy";

export default function EnterEmail() {
  const [email, setEmail] = useState('');
  const { emailError, continueAction } = useEnterEmailProxy({ email });

  const onEmailChange = useCallback((e: ChangeEvent<HTMLInputElement>) => setEmail(e.target.value), []);
  const onEmailKeyDown = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") continueAction.act();
  }, [continueAction]);

  return (
    <Flex direction="column" maxW={468} mx="auto" data-testid="enter-email-page-test">
      <Input
        autoFocus
        my={1}
        label="Your email"
        name="Email"
        id="email-field"
        type="email"
        onChange={onEmailChange}
        onKeyDown={onEmailKeyDown}
        placeholder="email@example.com"
        pattern="^[a-zA-Z0-9!#$%&'+^_`\{\}~\-]+(?:\.[a-zA-Z0-9!#$%&'+^_`\{\}~\-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-]*[a-zA-Z0-9])?$"
        maxLength={73}
        error={emailError}
        data-testid="email-input"
        spellCheck={false}
        isRequired={true}
        value={email}
        autoComplete="username"
      />
      <Button
        my={1}
        isFullWidth
        data-testid="continue-button-test"
        disabled={continueAction.disabled}
        onClick={continueAction.act}
      >
        Continue
      </Button>
    </Flex>
  );
}